import { useEffect, useState } from 'react';
import AircallWorkspace from 'aircall-everywhere';
import Draggable from 'react-draggable';
import clsx from 'clsx';

type PropsPhoneModal = {
  onHide: () => void;
  phoneNumber?: string;
  show: boolean;
};

export const PhoneModal: React.FC<PropsPhoneModal> = ({
  onHide,
  phoneNumber = '',
  show,
}) => {
  const [instance, setInstance] = useState<any>();

  useEffect(() => {
    const newInstance = new AircallWorkspace({
      domToLoadWorkspace: '#aircall-container',
      onLogin: () => {
        newInstance.send(
          'dial_number',
          { phone_number: phoneNumber },
          () => {}
        );
      },
      onLogout: () => {},
    });
    setInstance(newInstance);
  }, [setInstance, phoneNumber]);

  useEffect(() => {
    if (instance && phoneNumber) {
      instance?.send('dial_number', { phone_number: phoneNumber }, () => {});
    }
  }, [phoneNumber, instance]);

  const WIDGET_HEIGHT = 733;
  const WIDGET_MARGIN = 50;

  return (
    <Draggable
      handle=".handle"
      defaultPosition={{
        x: WIDGET_MARGIN,
        y: window.innerHeight - WIDGET_HEIGHT - WIDGET_MARGIN,
      }}
    >
      <div
        style={{
          cursor: 'grab',
          position: 'fixed',
          zIndex: 99999,
          opacity: show ? 1 : 0,
          pointerEvents: show ? 'auto' : 'none',
          overflow: 'hidden',
          transition: 'opacity 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
        }}
        className={clsx('handle card p-0', show && 'shadow')}
      >
        <header className="d-flex w-100 justify-content-between ps-7 pe-5 py-5 align-items-center">
          <span className="fw-bolder fs-3">Aircall Workspace</span>
          <button
            title="Minimizar"
            className="btn btn-sm btn-outline border-primary fs-9 w-35px px-2 text-center"
            onClick={onHide}
          >
            <i className="fa fa-window-minimize m-0 p-0" aria-hidden="true"></i>
          </button>
        </header>
        <div
          id="aircall-container"
          style={{
            marginBottom: '-5px',
          }}
        />
      </div>
    </Draggable>
  );
};
